module.exports = __webpack_public_path__ + "boy-blue-border.png";